import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import CampaignService from 'donor-elf-web/services/campaign-service';

export default class CampaignLabel extends Helper {
  @service declare campaignService: CampaignService;

  compute([campaignId]: string[], namedArgs?: { useCampaignName?: boolean }) {
    if (namedArgs?.useCampaignName) {
      return this.campaignService.campaignsById[campaignId]?.name;
    } else {
      return this.campaignService.campaignsById[campaignId]?.label;
    }
  }
}
